import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../../../../src/app/core/services/network-call.service';
import { fromRefreshTokenActions } from '../actions';
import * as fromToDoactions from '../../todos/actions';
import { IRefreshTokenRequest, IRefreshTokenResponse } from '../models/refresh-token.model';
import { mergeMap, catchError, switchMap, map } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { of } from 'rxjs';
import { SessionStorageIds } from '../../../../../src/app/shared/enums';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';

@Injectable()
export class RefreshTokenEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService
  ) {}

  refreshToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromRefreshTokenActions.loadRefreshTokenRequest),
      switchMap(action =>
        this.networkCallService.post<IRefreshTokenRequest, IRefreshTokenResponse>('Authentication/refreshToken', action.request).pipe(
          mergeMap((response: any) => {
            sessionStorage.setItem('token', response.accessToken);
            sessionStorage.setItem('refreshToken', response.refreshToken);
            sessionStorage.setItem(SessionStorageIds.TOKEN, response.accessToken);
            sessionStorage.setItem(SessionStorageIds.REFRESH_TOKEN, response.refreshToken);
            this.helperService.decodeJwtToken(response.accessToken);
            return [
              fromRefreshTokenActions.loadRefreshTokenSuccess({ response }),
              fromToDoactions.loadBusinesses({ param: '', noLoader: false })
            ];
          }),
          retryTransientHttpErrors(),
          catchError(error => {
            return of(fromRefreshTokenActions.loadRefreshTokenFailure(error));
          })
        )
      )
    )
  );
}
